import { Box } from "@mui/material"
import React, { useCallback, useEffect, useState } from "react"
import { TabBar } from "src/components/TabBar/TabBar"
import { Tabview } from "src/screens/Curated/Tabview"

import useSdk, { ErrorLevel } from "../../hooks/use-sdk"
import useTranslate from "../../hooks/use-translate"
import { appStore } from "../../store/AppStore"
import { comb } from "../../utilities/common"
import { dimensions, maxSliderSize } from "../../utilities/constants"
import { InfoModal } from "../Settings/Info/InfoModal"

export const HomeScreen = () => {
  const { height, width } = dimensions
  const minScreenHeight = appStore((state) => state.minScreenHeight)

  const sdk = useSdk(ErrorLevel.NoError)
  const setMyStage = appStore((state) => state.setMyStage)
  const accessToken = appStore((state) => state.accessTokenState)
  const loadMyStage = useCallback(async () => {
    const result = await sdk.myStagePage({
      sliderPageSize: maxSliderSize,
      cursor: undefined,
    })
    setMyStage(result)
  }, [sdk])
  useEffect(() => {
    if (accessToken) loadMyStage()
  }, [accessToken])

  const setPrompt = appStore((state) => state.setPrompt)
  const setTracking = appStore((state) => state.setTracking)
  // DPAPP-6833: require explicit consent for sentry
  const [completedConsent, setCompletedConsent] = useState(
    process.env.REACT_APP_TEST === "true",
  )
  const [infoModalOpen, setInfoModalOpen] = useState(false)
  const t = useTranslate()
  useEffect(() => {
    const userConsentedSentry = localStorage.getItem("sentry") !== null
    if (!userConsentedSentry && process.env.REACT_APP_TEST !== "true") {
      setPrompt({
        open: true,
        onConfirm: () => {
          setTracking({ type: "sentry", value: true })
          setCompletedConsent(true)
        },
        onClose: () => {
          setTracking({ type: "sentry", value: false })
          setCompletedConsent(true)
        },
        confirmButtonText: t("privacy__tracking_additional_consent_yes"),
        dismissButtonText: t("privacy__tracking_additional_consent_no"),
        dismissible: true,
        canClose: false,
        additionalButtons: [
          {
            text: t("privacy__tracking_additional_more_info"),
            onPress: () => setInfoModalOpen(true),
            focusKey: "SENTRYMOREINFO",
          },
        ],
        title: t("privacy__tracking_additional_consent_title"),
        message: t("privacy__tracking_additional_consent_sentry_explanation"),
        icon: "ALERT",
      })
    } else setCompletedConsent(true)
  }, [])

  if (!completedConsent)
    return (
      <InfoModal
        open={comb.ine(infoModalOpen, setInfoModalOpen)}
        content={t("page__privacy_content")}
        title={t("settings__privacy")}
        style={{ zIndex: 1304 /*display over prompt*/ }}
        returnFocusKey={"SENTRYMOREINFO"}
      />
    )

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: height,
          minWidth: width,
          height: minScreenHeight,
        }}
      >
        <TabBar />
        <Tabview />
      </Box>
    </>
  )
}
